var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "84", height: "12", viewBox: "0 0 84 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#a)" },
      React.createElement("path", { d: "M10.65.227H3.832L0 11.773h6.817c5.429 0 6.62-2.75 7.625-5.776 1.005-3.023 1.639-5.77-3.793-5.77zM9.592 6C8.556 9.123 8.17 9.608 6.349 9.608h-.935L7.81 2.392h.934c1.818 0 1.884.485.85 3.608zm13.956-6c-4.798 0-6.997 1.683-8.431 6-1.432 4.32-.35 6 4.448 6s7-1.683 8.431-6c1.435-4.317.35-6-4.448-6zm-.4 6c-1.038 3.123-1.466 3.963-2.907 3.963-1.44 0-1.312-.84-.275-3.963s1.466-3.963 2.906-3.963c1.44 0 1.312.84.275 3.963zm13.98-6c-4.797 0-6.996 1.683-8.43 6-1.432 4.32-.35 6 4.448 6s6.997-1.683 8.431-6c1.432-4.317.35-6-4.448-6zm-.4 6c-1.037 3.123-1.465 3.963-2.906 3.963-1.44 0-1.312-.84-.275-3.963s1.465-3.963 2.906-3.963c1.44 0 1.312.84.275 3.963zm16.83 2.444c1.401-4.22-6.646-3.105-5.89-5.385.17-.518.792-1.019 1.803-1.019.91 0 1.15.567.926 1.247l-.09.275h4.394c.82-2.474-.563-3.559-4.653-3.559s-6.335 1.276-7.105 3.605C41.587 7.7 49.337 6.567 48.58 8.847c-.21.63-.926 1.116-1.886 1.116-.909 0-1.423-.355-1.096-1.343l.09-.276h-4.544l-.134.406c-.795 2.392 1.094 3.25 4.983 3.25 4.141 0 6.755-1.1 7.57-3.56l-.003.004zM60.39.227l-8.227 11.549h5l1.15-2.023h3.739l-.19 2.023h4.999L66.297.227H60.39zm1.857 7.262H59.62l2.914-4.9h.052l-.339 4.9zM79.606.227l-2.361 7.116h-.051L76.526.227h-5.252l-3.832 11.549h4.395l2.366-7.131h.05l.765 7.13h5.153L84 .228h-4.394z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h84v12H0z" })
      )
    )
  );
});